import { showConnectionLostBanner, hideConnectionLostBanner, } from "../ui/ConnectionBanner";
// EventSource auto-reconnects on its own — this is just how long an outage must last before
// we bother telling the user, so a single dropped heartbeat doesn't flash a banner.
const CONNECTION_LOST_GRACE_MS = 5000;
// Owns the map's SSE connection, the parsed MapState it carries, and the indexes derived from
// it (street-tile lookup, per-user building ownership) — GameScene subscribes and renders.
export class MapStore {
    eventSource;
    connectionLostTimer = null;
    state = null;
    streetKeys = new Set();
    connect(eventsUrl, onUpdate) {
        // Server sends full MapState on connect and after every mutation; EventSource auto-reconnects
        // and syncMapState-style consumers are idempotent, so reconnect recovery is free.
        this.eventSource = new EventSource(eventsUrl);
        this.eventSource.addEventListener("open", () => this.onConnectionRecovered());
        this.eventSource.addEventListener("state", (e) => {
            this.onConnectionRecovered();
            try {
                const state = JSON.parse(e.data);
                this.state = state;
                this.streetKeys = new Set(state.streets.map((s) => `${s.x},${s.y}`));
                onUpdate(state);
            }
            catch (err) {
                console.error("Failed to parse SSE state message", err);
            }
        });
        this.eventSource.addEventListener("error", () => this.onConnectionError());
    }
    disconnect() {
        this.eventSource?.close();
        this.eventSource = undefined;
        if (this.connectionLostTimer) {
            clearTimeout(this.connectionLostTimer);
            this.connectionLostTimer = null;
        }
        hideConnectionLostBanner();
    }
    onConnectionError() {
        if (this.connectionLostTimer)
            return;
        this.connectionLostTimer = setTimeout(() => {
            showConnectionLostBanner();
            this.connectionLostTimer = null;
        }, CONNECTION_LOST_GRACE_MS);
    }
    onConnectionRecovered() {
        if (this.connectionLostTimer) {
            clearTimeout(this.connectionLostTimer);
            this.connectionLostTimer = null;
        }
        hideConnectionLostBanner();
    }
    getState() {
        return this.state;
    }
    getStreetKeys() {
        return this.streetKeys;
    }
    buildingsOwnedBy(userId) {
        return (this.state?.buildings ?? []).filter((b) => b.ownerId === userId);
    }
    manualBuildingCountForUser(userId) {
        return (this.state?.buildings ?? []).filter((b) => b.kind === "company" && b.source === "manual" && b.ownerId === userId).length;
    }
}
